import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { ErrorNotificationService, errorMessageFor } from './error-notification.service';

const LOCALLY_HANDLED_PATHS = ['/api/user/current', '/logout'];

const requestPathname = (url: string): string => {
  try {
    return new URL(url).pathname;
  } catch {
    const [path] = url.split(/[?#]/, 1);
    return path.startsWith('/') ? path : `/${path}`;
  }
};

const isAllConceptsRequest = (request: Parameters<HttpInterceptorFn>[0]): boolean => {
  return (
    request.method === 'GET' &&
    /^\/projects\/[^/]+\/branches\/[^/]+\/concepts$/.test(requestPathname(request.url))
  );
};

/**
 * Shows a safe global toast for failed API requests while preserving each caller's
 * original error so existing local error handling continues to work.
 */
export const errorNotificationInterceptor: HttpInterceptorFn = (request, next) => {
  const notifications = inject(ErrorNotificationService);
  const pathname = requestPathname(request.url);
  const isLocallyHandled =
    LOCALLY_HANDLED_PATHS.some(path => pathname.endsWith(path)) || isAllConceptsRequest(request);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (!isLocallyHandled) {
        notifications.showError(errorMessageFor(error));
      }
      return throwError(() => error);
    })
  );
};
